import { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { Link } from 'react-router-dom';

export default function LegalPage({ file, title }) {
  const [content, setContent] = useState('');

  useEffect(() => {
    fetch(file).then(r => r.text()).then(setContent);
  }, [file]);

  return (
    <div style={S.page}>
      <div style={S.container}>
        <Link to="/" style={S.back}>← Back to Candid</Link>
        <div style={S.markdown}>
          <ReactMarkdown
            components={{
              // eslint-disable-next-line jsx-a11y/heading-has-content
              h1: ({ node, children, ...p }) => <h1 style={S.h1} {...p}>{children}</h1>,
              // eslint-disable-next-line jsx-a11y/heading-has-content
              h2: ({ node, children, ...p }) => <h2 style={S.h2} {...p}>{children}</h2>,
              // eslint-disable-next-line jsx-a11y/heading-has-content
              h3: ({ node, children, ...p }) => <h3 style={S.h3} {...p}>{children}</h3>,
              p: ({ node, children, ...p }) => <p style={S.p} {...p}>{children}</p>,
              ul: ({ node, children, ...p }) => <ul style={S.ul} {...p}>{children}</ul>,
              li: ({ node, children, ...p }) => <li style={S.li} {...p}>{children}</li>,
              strong: ({ node, children, ...p }) => <strong style={S.strong} {...p}>{children}</strong>,
              // eslint-disable-next-line jsx-a11y/anchor-has-content
              a: ({ node, children, ...p }) => <a style={S.a} {...p}>{children}</a>,
            }}
          >
            {content}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  );
}

const S = {
  page: { minHeight: '100vh', background: '#030010', color: '#e5e5e5', fontFamily: 'system-ui, -apple-system, sans-serif', padding: '40px 20px' },
  container: { maxWidth: 720, margin: '0 auto' },
  back: { color: '#a78bfa', textDecoration: 'none', fontSize: 13, fontWeight: 600, marginBottom: 32, display: 'inline-block' },
  markdown: { lineHeight: 1.7, fontSize: 15 },
  h1: { fontSize: 36, fontWeight: 900, letterSpacing: -1.5, marginTop: 40, marginBottom: 16, background: 'linear-gradient(90deg, #a78bfa, #f472b6, #fb923c)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' },
  h2: { fontSize: 22, fontWeight: 800, letterSpacing: -0.5, marginTop: 36, marginBottom: 12, color: '#fff' },
  h3: { fontSize: 16, fontWeight: 700, marginTop: 24, marginBottom: 8, color: '#fff' },
  p: { color: '#bbb', margin: '12px 0' },
  ul: { color: '#bbb', paddingLeft: 24, margin: '12px 0' },
  li: { margin: '8px 0' },
  strong: { color: '#fff', fontWeight: 700 },
  a: { color: '#a78bfa' },
};
